import * as React from "react";
import { styled } from "@mui/material";

//region [[ Styles ]]

const FourOFourView = styled("div")({
  display: "flex",
  flexFlow: "column",
  alignItems: "center",
  justifyContent: "center",
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface FourOFourProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const FourOFour = ({ ...props }: FourOFourProps) => {
  return (
    <FourOFourView>
      <h1>Oops... we got a MOF</h1>
      <h2>
        try hitting back, or checking your address, if you keep getting this MOF
        send us an email at{" "}
        <a href="mailto://support@kahun.com">support@kahun.com</a> to save the
        day :)
      </h2>
    </FourOFourView>
  );
};
